
















import { Vue, Component, Prop } from "vue-property-decorator";

import { ExportStage } from "../data/ChatExportDataLoader";
import ChatExportMessage from "./ChatExportMessage.vue";

@Component({
    components: { ChatExportMessage }
})
export default class ChatExportMessages extends Vue {
    @Prop({required: true}) messageGroup: ExportStage;
    @Prop({required: true}) title: string;
    @Prop({required: true}) name: string;
}
